import { useLocaleState, useRecordContext } from "react-admin";

import formatDate from "../../unit/formatDate";
import LabelField from "../../unit/LabelField";
import { Grid } from "@mui/material";

const InitialLog = ({ ...props }) => {
  const { appId, checkStep, attrs } = props;
  const record = useRecordContext();
  const [locale] = useLocaleState();
  if (!record) return null;
  // console.log("====>", record);
  return (
    <>
      <Grid container spacing={1} sx={{ mb: 1 }}>
        <Grid item xs={12} md={6} lg={6}>
          <LabelField
            title="Date Checked"
            value={
              checkStep?.checkAt && checkStep.checkAt != "0000-00-00 00:00:00"
                ? checkStep?.checkAt
                : ""
            }
            prefix="EST"
          />
          <LabelField title="Checked By" value={checkStep?.checkOper} />
          <LabelField
            title="Account #"
            value={
              checkStep?.accountOpen == "yes" ? checkStep?.memberNum : "New"
            }
          />
          {
            // attrs["MLAStatus"] && attrs["MLAStatus"] != "N/A"
            attrs?.MLAStatus && attrs?.MLAStatus != "N/A" && (
              <LabelField
                title="MLA Status"
                value={attrs?.MLAStatus ? attrs?.MLAStatus : "N/A"}
              />
            )
          }
          {record?.checkStep?.existing_account_type && (
            <LabelField
              title="Existing Account Type"
              value={
                record?.checkStep?.existing_account_type
                  ? record?.checkStep?.existing_account_type
                  : "N/A"
              }
            />
          )}
          {record?.checkStep?.existing_account_number && (
            <LabelField
              title="Existing Account"
              value={
                record?.checkStep?.existing_account_number
                  ? record?.checkStep?.existing_account_number
                  : "N/A"
              }
            />
          )}

          {
            // attrs["Meet Program Requirements"] &&
            //   attrs["Meet Program Requirements"] != "N/A"
            attrs?.["Meet Program Requirements"] &&
              attrs?.["Meet Program Requirements"] != "N/A" && (
                <LabelField
                  title="Meet Program Requirements"
                  value={
                    attrs["Meet Program Requirements"]
                      ? attrs["Meet Program Requirements"]
                      : "N/A"
                  }
                />
              )
          }

          {
            // attrs["checkofca"] && attrs["checkofca"] != "N/A"
            attrs?.checkofca && attrs?.checkofca != "N/A" && (
              <LabelField
                title="OFAC Check"
                value={attrs?.checkofca ? attrs?.checkofca : "N/A"}
              />
            )
          }
          {
            // attrs["creditScore"] && attrs["creditScore"] != "N/A"
            attrs?.creditScore && attrs?.creditScore != "N/A" && (
              <LabelField
                title="Soft-Pull Credit Score"
                value={attrs?.creditScore ? attrs?.creditScore : "N/A"}
              />
            )
          }
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          {record?.sComment && record?.sComment.length > 0 ? (
            <LabelField
              title="Comment"
              value={record.sComment}
              format="richtext"
              titlePosition="top"
            />
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default InitialLog;
